import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { lanesAPI } from "components/Apis/lanesAPI";

export const fetchLanes = createAsyncThunk(
    'filter/fetchLanes',
    async (_, { rejectWithValue }) => {
        try {
            const response = await lanesAPI.getAll();
            return response.data;  // Returns the fetched lanes data
        } catch (error) {
            // Handle errors with a fallback to error.message if response data is not available
            let errorMessage = 'An unexpected error occurred.';
            if (error.response) {
                // API responded with an error
                errorMessage = error.response?.data || error.message;
            } else if (error.request) {
                // No response from the API (e.g., network error)
                errorMessage = 'Network error, please try again later.';
            }
            return rejectWithValue(errorMessage);  // Sends error message to the redux store
        }
    }
);

export const fetchLaneStatuses = createAsyncThunk(
    'filter/fetchLaneStatuses',
    async (_, { rejectWithValue }) => {
        try {
            const response = await lanesAPI.getAllStatuses();
            return response.data;  // Returns the fetched lane statuses data
        } catch (error) {
            // Handle errors with a fallback to error.message if response data is not available
            let errorMessage = 'An unexpected error occurred.';
            if (error.response) {
                // API responded with an error
                errorMessage = error.response?.data || error.message;
            } else if (error.request) {
                // No response from the API (e.g., network error)
                errorMessage = 'Network error, please try again later.';
            }
            return rejectWithValue(errorMessage);  // Sends error message to the redux store
        }
    }
);

const laneSlice = createSlice({
    name: 'lanes',
    initialState: {
        lanes: null,         
        loading: false,      
        error: null,
        laneStatuses: { loading: false, error: null, data: null } // Initialize laneStatuses with loading and error states
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLanes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLanes.fulfilled, (state, action) => {
                state.loading = false;
                state.lanes = action.payload; // Store the list of people
            })
            .addCase(fetchLanes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
        builder
            .addCase(fetchLaneStatuses.pending, (state) => {
                state.laneStatuses.loading = true;
                state.laneStatuses.error = null;
            })
            .addCase(fetchLaneStatuses.fulfilled, (state, action) => {
                state.laneStatuses.loading = false;
                state.laneStatuses.data = action.payload; // Store the list of lane statuses
            })
            .addCase(fetchLaneStatuses.rejected, (state, action) => {
                state.laneStatuses.loading = false;
                state.laneStatuses.error = action.payload; // Store error message
            });
    },
});

export default laneSlice.reducer;